export default __webpack_public_path__ + "static/media/banner-title.6ba46156.png";